import app from '$$app';
import showAuthWindow from '../../views/profileSettings/include/integrations/showAuthWindow';
import rights from '../../components/rights/index';
import { api } from '$$store/api';

const integrationMSTeamsModel = new webix.DataCollection();

if (app.config.mode.isBase) {
  api.get('integrations/msteams').then(response => {
    integrationMSTeamsModel.parse(response.data);
  }).catch(() => {
    integrationMSTeamsModel.parse([]);
  });
}

function processListDataFromTeams(response) {
  const data = response.data;

  if (data.error && data.error === 'invalid_token_scope') {
    showAuthWindow({ isOwner: rights.account.isOwner(), type: 'msteams', update_user_token: true });

    return [];
  }

  return data;
}

integrationMSTeamsModel.getTeams = () => api.get('/integrations/msteams/teams')
  .then(processListDataFromTeams)
  .catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.getChannels = teamId => api.get(`/integrations/msteams/teams/${teamId}/channels`)
  .then(processListDataFromTeams)
  .catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.removeConnection = data => api.delete('/integrations/msteams', { data })
  .then(data => {
    const result = data.data;

    integrationMSTeamsModel.remove(result.id);

    return result;
  })
  .catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.getData = async () => api.get('/integrations/msteams')
  .then(result => {
    const data = result.data;

    integrationMSTeamsModel.clearAll();
    integrationMSTeamsModel.parse(data);
    const _data = integrationMSTeamsModel.serialize();

    _data.forEach(element => {
      element.editMode = false;
    });

    return _data;
  }).catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.addConnection = data => api.post('/integrations/msteams/addConnection', data)
  .then(data => {
    const result = data.data;

    if (result.status === 200) {
      integrationMSTeamsModel.add(result.item);
    }

    return result;
  }).catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.editConnection = data => {
  const itemId = data.channelProjectId;

  return api.post('/integrations/msteams/editConnection', data)
    .then(data => {
      const result = data.data;

      if (result.status === 200) {
        let cItem = integrationMSTeamsModel.getItem(itemId);

        cItem = result.item;
        integrationMSTeamsModel.updateItem(itemId, cItem);
      }

      return result;
    }).catch(err => {
      new Error(err);
    });
};

integrationMSTeamsModel.removeAllConnections = () => integrationMSTeamsModel.clearAll();

integrationMSTeamsModel.getDataFromCollection = () => integrationMSTeamsModel.serialize();

integrationMSTeamsModel.saveSetting = data => api.post('/integrations/msteams/saveSetting', data)
  .then(response => {
    const result = response.data;

    if (result.status === 'ok') {
      const cItem = integrationMSTeamsModel.getItem(data.id);

      cItem[data.settingType] = data.value;
      integrationMSTeamsModel.updateItem(data.id, cItem);
    }

    return result;
  }).catch(err => {
    new Error(err);
  });

integrationMSTeamsModel.attachEvent('onAfterAdd', id => {
  app.trigger('integration:msteams:updated');
  app.trigger('integration:msteams:addNewItem');
});

integrationMSTeamsModel.attachEvent('onDataUpdate', id => {
  app.trigger('integration:msteams:updated');
});

integrationMSTeamsModel.attachEvent('onAfterDelete', id => {
  app.trigger('integration:msteams:updated');
});

app.socket.on('integration:socket:service_url_updated', data => {
  const { connectionsList, serviceUrl } = data;
  let triggerUpdate = false;

  connectionsList.forEach(connectionId => {
    const connection = integrationMSTeamsModel.getItem(connectionId);

    if (!connection) return;
    if (!triggerUpdate) triggerUpdate = true;
    connection.service_url = serviceUrl;
    connection.waitingForActivation = false;
    integrationMSTeamsModel.updateItem(connectionId, connection);
  });

  triggerUpdate && app.trigger('integration:msteams:service_url_updated');
});

export { integrationMSTeamsModel };
